export const pincode = {
    /**
    * Gets the programmatic name of the entire locale, with the language, 
    *   country and variant separated by underbars. The Language is always lower case, 
    *   and country is always upper case. If the language is missing, 
    *   the string will begin with an underscore character. 
    *   If both the language and country fields are missing, 
    *   this function will return the empty string, 
    *   even if the variant field is filled in (you cannot have a locale with just a variant-- 
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
    en: {
        pincode:'Pincode',
        pincode_id:'Pincode Id',
        pincode_management:'Pincode Management',
        add_pincode:'Add Pincode',
        edit_pincode:'Edit Pincode',
        cancel:'cancel',
        submit:'submit',
        pincode_information:'Pincode Information',
        pincode_name:'Pincode Name',
        city:'City',
        pincode_status:'Pincode Status',
        delete_confrim_msg:"Are you sure you want to delete this pincode list?",
    },
    ar: {
        pincode:'الرمز السري',
        pincode_id:'معرف الرمز السري',
        pincode_management:'إدارة الرمز السري',
        add_pincode:'أضف الرمز السري',
        edit_pincode:'تحرير الرمز السري',
        cancel:'إلغاء',
        submit:'إرسال',
        pincode_information:'معلومات الرمز السري',
        pincode_name:'اسم الرمز السري',
        city:'المدينة',
        pincode_status:'حالة الرمز السري',
        delete_confrim_msg:"هل أنت متأكد أنك تريد حذف قائمة الرمز السري هذه؟",
        
    }

}